import { Common } from '@stockbit/ui';
import { Divider } from 'antd';
import styled from 'styled-components';

const { Modal: SbModal } = Common;

export const Modal = styled(SbModal)`
  & > .ant-modal-content {
    border-radius: 3px;
  }

  & .ant-modal-close-x {
    font-size: 11px;
  }

  max-width: 400px;
`;

export const HeaderWrapper = styled.div`
  padding: 20px 20px 0;
`;

export const ContentWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  & > * {
    margin-bottom: 16px;

    &:last-child {
      margin: 0;
    }
  }
`;

export const LottieWrapper = styled.div`
  width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const InfoTextWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const DebtRatioInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ededed;
  width: 100%;
  padding: 17px 16px;
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  p {
    margin: 0;
    max-width: 50%;
  }
`;

export const DividerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 0 16px;
`;

export const SymbolChip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0 6px;
  border-radius: 8px;
  border: 1px solid #ededed;
  height: 18px;
`;

export const RowDivider = styled(Divider)`
  margin: 0;
  width: 100%;
`;

export const DebtRatioBanner = styled.div`
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f2f1fe;
`;
